module.exports = __webpack_public_path__ + "static/media/user.0630ecb3.svg";